import React from 'react'
import styled from 'styled-components'

import { Trad } from './Trad'

const getBorder = ({ color, backcolor }) => (
  backcolor !== 'transparent' ? 'transparent' : color
)

const TagItem = styled.div`
  width: fit-content;
  padding: 2px 8px 2px 8px;
  margin: 10px 10px 10px 0px;
  background-color: ${({ backcolor }) => backcolor};
  color: ${({ color }) => color};
  font-weight: bold;
  border: 1px solid ${({ color, backcolor }) => getBorder({ color, backcolor })};
  border-radius: 5px;
`

export const Tag = ({ label, color, filled }) => (
  <TagItem backcolor={filled ? color : 'transparent'} color={filled ? 'white' : color}>
    <Trad id={label} />
  </TagItem>
)
